const nsi = '/api/nsi';

export default {
  nsitnved: {
    search: `${nsi}/nsitnved/search`,
    byIDs: `${nsi}/nsitnved/listbyids`,
  },
  nsi: {
    nsiCountryWithData: `${nsi}/countryListWithData`,
    nsiMpkBusinessStatus: `${nsi}/nsimpkbusinessstatus/search`,
  },
  menu: {
    getMenu: '/api/menu/menu',
  },
};
